package com.mrpowergamerbr.puppydough

object WADUtils {
    val WAD_FILENAMES = listOf(
        "data.win",   // Windows
        "game.unx",   // Linux
        "game.ios",   // iOS
        "game.droid", // Android
        "game.psp",   // PSP
        "game.win",   // PSVita
        "game.osx",   // macOS
    )
}